module.exports = __webpack_public_path__ + "static/media/blue_nebula_LF.172b92ac.png";